import { getRandomUniqueColor, getLineGraphFormat } from "./format-utils";
import {
  VERTICALS,
  GRAPH_TYPES,
  CONSTANTS,
} from "../../../constants/app-constant";

const { AREA } = GRAPH_TYPES;
const {
  REPORTS: { TYPES },
} = CONSTANTS;

export const formatThematicAnalysisEntity = (
  d,
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
      countKey,
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    let returnData = d[rType] && d[rType].returnData;
    const entityList = returnData.map((entityObj) => entityObj.entity_name);
    const tagList = [];
    for (const entityObj of returnData) {
      for (const tagObj of entityObj.data) {
        if (tagList.indexOf(tagObj.category_name) < 0) {
          tagList.push(tagObj.category_name);
        }
      }
    }

    const graphColors = getRandomUniqueColor(tagList.length);
    const datasets = tagList.map((tag, index) => {
      let data = returnData.map((entityInfo) => {
        const currentTagObj =
          (entityInfo.data &&
            entityInfo.data.filter((e) => e.category_name === tag)[0]) ||
          {};
        return currentTagObj[countKey] || "0";
      });
      data = isLineGraph ? getLineGraphFormat(data) : data;
      return {
        label: tag,
        backgroundColor:
          graph_type === AREA && typeof window.Color === "function"
            ? window.Color(graphColors[index]).alpha(0.5).rgbString()
            : graphColors[index],
        borderColor: graphColors[index],
        borderWidth: 1,
        data,
        barThickness: "flex",
        fill: graph_type === AREA ? "start" : false,
        lineTension: 0,
      };
    });

    return {
      labels: entityList,
      datasets,
    };
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};

export const formatThematicAnalysisTag = (
  d,
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
      countKey,
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    let returnData = d[rType] && d[rType].returnData;
    const tagList = returnData.map((tagObj) => tagObj.category_name);
    const entityList = [];
    for (const tagObj of returnData) {
      for (const entityObj of tagObj.data) {
        if (entityList.indexOf(entityObj.entity_name) < 0) {
          entityList.push(entityObj.entity_name);
        }
      }
    }

    const graphColors = getRandomUniqueColor(tagList.length);
    const datasets = entityList.map((entity, index) => {
      let data = returnData.map((tagInfo) => {
        const currentEntityObj =
          (tagInfo.data &&
            tagInfo.data.filter((e) => e.entity_name === entity)[0]) ||
          {};
        return currentEntityObj[countKey] || "0";
      });
      data = isLineGraph ? getLineGraphFormat(data) : data;
      return {
        label: entity,
        backgroundColor:
          graph_type === AREA && typeof window.Color === "function"
            ? window.Color(graphColors[index]).alpha(0.5).rgbString()
            : graphColors[index],
        borderColor: graphColors[index],
        borderWidth: 1,
        data,
        barThickness: "flex",
        fill: graph_type === AREA ? "start" : false,
        lineTension: 0,
      };
    });
    return {
      labels: tagList,
      datasets,
    };
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};
